export default "__VITE_ASSET__01e30a1c__"